export const styles = {
  margin: {
    marginTop: 1.5,
  },
  internalDivider: {
    borderColor: 'gray.8',
  },
  openedMultipleAgreementWrapper: {
    paddingTop: 0,
  },
  multipleAgreementWrapper: {
    paddingTop: 1.5,
    paddingBottom: 0,
    flexDirection: 'column',
    display: 'flex',
  },
  buttonWrapper: {
    marginBottom: 2,
  },
  openedSummary: {
    '.MuiAccordionSummary-content': {
      marginBottom: 0,
    },
  },
  accordionContent: {
    '.MuiAccordionDetails-root': {
      padding: 0,
    },
    marginBottom: 0,
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  accordionWrapper: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    flexGrow: 1,
  },
  accordionSummary: {
    marginLeft: 0,
    marginRight: 0,
    border: 0,
    '& .MuiAccordionSummary-expandIconWrapper': {
      marginRight: 0,
    },
  },
}
